import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Unselect = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm4 1h8V7H4v2z"
        fill="#E4002B"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Unselect.category = 'undefined-category';

Unselect.displayName = 'Unselect';
